import * as React from 'react';
import dayjs from 'dayjs';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import isToday from 'dayjs/plugin/isToday';
import { convertUnixToDate } from '@lean-body/src/util';
import { Link } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { useSmMediaQuery } from '@lean-body/src/util/media_query_hooks';
import { css, StyleSheet } from 'aphrodite';
import { LiveLessonAttendanceButton, LiveLessonCardHeader, LiveLessonThumbnail } from '@lean-body/components/molecules';
dayjs.extend(isTomorrow);
dayjs.extend(isToday);
export const LiveLessonCard = ({ liveLesson, tracker, classObject, onClickAttendance }) => {
    const [isAttendance, setIsAttendance] = React.useState(liveLesson.isSubscribed);
    const isSM = useSmMediaQuery();
    const liveLessonLinkPath = (live) => {
        if (live.isWatchable) {
            return routes.LIVE_LESSON.compile({ id: live.id.toString() });
        }
    };
    const onClick = (id) => {
        onClickAttendance(id, isAttendance);
        setIsAttendance(!isAttendance);
    };
    const onClickThumbnail = (id) => {
        tracker.trackClickEvent({
            category: 'Clicked live lesson thumbnail',
            label: `LiveLessonID: ${id}`,
        });
    };
    const holdingDay = (startDate) => {
        if (dayjs(startDate).isToday()) {
            return '今日';
        }
        if (dayjs(startDate).isTomorrow()) {
            return '明日';
        }
        return dayjs(startDate).format('M月D日 dddd');
    };
    const holdingDate = () => {
        const startDate = convertUnixToDate(liveLesson.startsAt);
        const endDate = convertUnixToDate(liveLesson.lessonEndAt);
        const day = holdingDay(startDate);
        return `${day} ${dayjs(startDate).format('H:mm')}~${dayjs(endDate).format('H:mm')}`;
    };
    return (React.createElement(React.Fragment, null, liveLesson && (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(LiveLessonCardHeader, { label: liveLesson.label, holdingTime: holdingDate(), classObject: styles.cardHeader }),
        React.createElement(Link, { to: liveLessonLinkPath(liveLesson), className: css(styles.container), onClick: () => onClickThumbnail(liveLesson.id) },
            React.createElement(LiveLessonThumbnail, { src: isSM ? liveLesson.thumbnailSpURL : liveLesson.thumbnailPcURL, isWatchable: liveLesson.isWatchable, isArchiveTranscodingComplete: null })),
        !liveLesson.isArchived && (React.createElement(LiveLessonAttendanceButton, { isAttendance: isAttendance, onClick: () => onClick(liveLesson.id), classObject: styles.liveLessonAttendanceButton }))))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
    },
    cardHeader: {
        marginBottom: 12,
    },
    liveLessonAttendanceButton: {
        position: 'absolute',
        bottom: 10,
        right: 10,
    },
});
